import { EReasonsKey } from "shared"

export const RdvReasons: { key: EReasonsKey; title: string }[] = [
  {
    key: EReasonsKey.MODALITE,
    title: "Modalités d'inscription",
  },
  {
    key: EReasonsKey.PLACE,
    title: "Places disponibles",
  },
  {
    key: EReasonsKey.ACCOMPAGNEMENT,
    title: "Accompagnement dans la recherche d'entreprise",
  },
  {
    key: EReasonsKey.FRAIS,
    title: "Frais d'inscription",
  },
  {
    key: EReasonsKey.CONTENU,
    title: "Contenu de la formation",
  },
  {
    key: EReasonsKey.HORAIRE,
    title: "Horaires / rythme de la formation",
  },
  {
    key: EReasonsKey.DEBOUCHE,
    title: "Situation des élèves en sortie de formation",
  },
  {
    key: EReasonsKey.PLUS,
    title: "En savoir plus sur l'alternance",
  },
  {
    key: EReasonsKey.SUIVI,
    title: "Suivi de ma candidature",
  },
  {
    key: EReasonsKey.LIEU,
    title: "Lieu de la formation",
  },
  {
    key: EReasonsKey.PORTE,
    title: "Portes ouvertes",
  },
  {
    key: EReasonsKey.AUTRE,
    title: "Autre :",
  },
]
